import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { httpGetUser } from '../../Hooks/user/user.get.hooks';
import Auth from '../../Helpers/auth';
import ErrorMessage from '../../Components/ErrorPage/Error.component';
import HomepageLoading from '../../Components/LoadingPages/LoadingHome.component';
import PropTypes from 'prop-types';

// FOR THE USER HOME DATA
const UserHomeDataProvider = ({ children, showLoading = true }) => {
  // Use the passed `userId` prop if available, otherwise fall back to Auth.getProfile()
  const { data } = Auth.getProfile();
  const userId = data?.id || localStorage.getItem('temp_id');

  const {
    data: user,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['user', userId],
    queryFn: () => httpGetUser(userId),
    enabled: !!userId, // Only enable the query if userId is valid
    staleTime: 5 * 60 * 1000,
    retry: 4,
    select: (data) => {
      const allCourses = data?.courses || [];
      const incompleteCourses = allCourses?.filter(
        (course) => !course?.complete
      );
      const completeCourses = allCourses?.filter((course) => course?.complete);
      const subcontractorCompanies = data?.company.filter(
        (c) => c.type === 'Subcontractor'
      );
      return {
        ...data,
        subcontractorCompanies,
        allCourses,
        incompleteCourses,
        completeCourses,
      };
    },
    onError: (error) => {
      console.error('Error fetching user data:', error); // Debugging log
    },
  });
  // console.log('User home data', user);

  if (isLoading && showLoading) return <HomepageLoading />;
  if (isError) return <ErrorMessage message="Failed to load user data." />;

  return children(user);
};

UserHomeDataProvider.propTypes = {
  children: PropTypes.func,
  showLoading: PropTypes.bool,
};

export default UserHomeDataProvider;
